export default __webpack_public_path__ + "img/marker.56089d9a.png";